import React, { useContext } from "react";
import { Stores, StoresContext } from "Globals/Stores";
import { UserDetails } from "./UserDetails";
import { RoleDetails } from "./RoleDetails";
import { User } from "Globals/Models";
import { Admin } from "./Admin";
import { AdminApplicantsListView } from "./Applicants/AdminApplicantsListView";
import { PrivateRoute } from "Globals/Views/PrivateRoute";
import { AdminApplicantView } from "./Applicants/Applicant/AdminApplicantView";

export const AdminRoutes: React.FC = () => {
    const store = useContext<Stores>(StoresContext);
    return (
        <>
            <PrivateRoute
                exact
                path="/user"
                component={User}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && store.Domain.AccountStore.isInRole("admin");
                }}
            />
            <PrivateRoute
                exact
                path="/admin/applicant/:applicantId?"
                component={AdminApplicantView}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && store.Domain.AccountStore.isInRole("admin");
                }}
            />
            <PrivateRoute
                exact
                path="/admin/applicants"
                component={AdminApplicantsListView}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && store.Domain.AccountStore.isInRole("admin");
                }}
            />
            <PrivateRoute
                exact
                path="/admin"
                component={Admin}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && store.Domain.AccountStore.isInRole("admin");
                }}
            />
            <PrivateRoute
                exact
                path="/roleslist/role/:id"
                component={RoleDetails}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && store.Domain.AccountStore.isInRole("admin");
                }}
            />
            <PrivateRoute
                exact
                path="/userslist/user/:id"
                component={UserDetails}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && store.Domain.AccountStore.isInRole("admin");
                }}
            />
        </>
    );
};
